/*
    Header
*/

// Background Color
var select = document.getElementById('background-header-color-selector');
var colorPreview = document.getElementById('color-preview-header');
var header = document.getElementsByTagName('header')[0];
var content = document.getElementsByClassName('content')[0];

window.updateColorHeader = function() {
    select.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    select.appendChild(option);

    colorPreview.style.backgroundColor = "transparent";
    colorPreview.style.border = "#5D5D5D 1px solid";

    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        select.appendChild(option);
    }
}

select.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreview.style.backgroundColor = val.settings.color;
            window.customStyle['header']['background-color'] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }

    if (event.target.value == "") {
        colorPreview.style.backgroundColor = "transparent";
        colorPreview.style.border = "#5D5D5D 1px solid";
        window.customStyle['header']['background-color'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreview.style.border = "transparent";
    }
})

// Height
var headerHeight = document.getElementById('header-height');
headerHeight.addEventListener('change', function(event) {
    window.customStyle["header"]["height"] = event.target.value + " !important";;
    window.customStyle[".content"]["height"] = "calc(100% - "+event.target.value+") !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
});

// Logo Link
var logoLink = document.getElementById('logo-link');
logoLink.addEventListener('change', function(event) {
    var logo = document.getElementsByClassName('logo')[0];
    logo.src = event.target.value;

    window.customJSON["logo"]["src"] = event.target.value;
});

// Logo Width
var logoWidth = document.getElementById('logo-width');
logoWidth.addEventListener('change', function(event) {
    window.customStyle[".logo"]["width"] = event.target.value;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Logo Height
var logoHeight = document.getElementById('logo-height');
logoHeight.addEventListener('change', function(event) {
    window.customStyle[".logo"]["height"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Border
var borderColor = "black";
var borderWidth = "1px";
var borderString = borderWidth + " solid " + borderColor;

var selectBorderPos = document.getElementById('header-border-selector');
selectBorderPos.addEventListener('change', function(event) {
    if (event.target.value == "inside") {
        window.customStyle["header"]["box-sizing"] = "border-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        window.customStyle["header"]["box-sizing"] = "content-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    }
})

var selectBorder = document.getElementById('header-border-color-selector');
var colorPreviewBorder = document.getElementById('color-border-preview-header');
window.updateHeaderBorderColor = function() {
    selectBorder.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectBorder.appendChild(option);

    colorPreviewBorder.style.backgroundColor = "transparent";
    colorPreviewBorder.style.border = "#5D5D5D 1px solid";
    
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectBorder.appendChild(option);
    }
}

selectBorder.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewBorder.style.backgroundColor = val.settings.color;

            borderColor = val.settings.color;
            borderString = borderWidth + " solid " + borderColor;
            window.customStyle["header"]["border"] = borderString + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewBorder.style.backgroundColor = "transparent";
        colorPreviewBorder.style.border = "#5D5D5D 1px solid";
        window.customStyle['header']['border'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewBorder.style.border = "transparent";
    }
});

var widthBorder = document.getElementById('width-border-header');
widthBorder.addEventListener('change', function(event) {
    borderWidth = event.target.value;
    borderString = borderWidth + " solid " + borderColor;
    window.customStyle["header"]["border"] = borderString + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Shadow
var hOffset = "0px";
var vOffset = "0px";
var blurShadow = "0px";
var spreed = "0px";
var shadowColor = "#000";
var shadowPos = "";

var hOffsetElement = document.getElementById("header-shadow-h-offset");
hOffsetElement.addEventListener("change", function(event) {

    hOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos;

    window.customStyle["header"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var vOffsetElement = document.getElementById("header-shadow-v-offset");
vOffsetElement.addEventListener("change", function(event) {

    vOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos;

    window.customStyle["header"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var blurElement = document.getElementById("header-shadow-blur");
blurElement.addEventListener("change", function(event) {

    blurShadow = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos;

    window.customStyle["header"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var spreedElement = document.getElementById("header-shadow-spreed");
spreedElement.addEventListener("change", function(event) {

    spreed = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos;

    window.customStyle["header"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var selectShadow = document.getElementById('header-shadow-color-selector');
var colorPreviewShadow = document.getElementById('color-shadow-preview-color');
window.updateHeaderShadowColor = function() {
    selectShadow.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectShadow.appendChild(option);

    colorPreviewShadow.style.backgroundColor = "transparent";
    colorPreviewShadow.style.border = "#5D5D5D 1px solid";
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectShadow.appendChild(option);
    }
}
selectShadow.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewShadow.style.backgroundColor = val.settings.color;

            shadowColor = val.settings.color;
            var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos;
            window.customStyle["header"]["box-shadow"] = shadow + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewShadow.style.backgroundColor = "transparent";
        colorPreviewShadow.style.border = "#5D5D5D 1px solid";
        window.customStyle['header']['box-shadow'] = "none !important";
        shadowColor = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewShadow.style.border = "transparent";
    }
});

var shadowPosElement = document.getElementById("header-shadow-position");
shadowPosElement.addEventListener("change", function(event) {
    if (event.target.value == "inner") {
        shadowPos = "inset";
    } else {
        shadowPos = "";
    }
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos;

    window.customStyle["header"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})